/**
 * TextEditNode.tsx
 * TextEditノードのビューコンポーネント
 * 入力した文字を表示し、設定はダイアログで行う
 */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { TextEditNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const TextEditNodeView = memo(function TextEditNodeView({ data }: NodeProps<TextEditNode>) {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="textEdit"
      accent="emerald"
      title={getNodeDisplayLabel('textEdit', displayLanguage)}
      summary={data.text ?? ''}
    >
      <Handle type="target" position={Position.Left} className="!bg-emerald-500" />
      <Handle type="source" position={Position.Right} className="!bg-emerald-500" />
    </CardShell>
  );
});
